import { styled } from '@mui/material';

export const PaletteControlRoot = styled('div')({
  marginBottom: '1rem',
});

export const PalettePreview = styled('div')({
  width: '5rem',
  height: '1rem',
  display: 'flex',
  alignItems: 'stretch',

  '& > div': {
    flex: '1 1 100%',
  },

  '& img': {
    width: '100%',
    height: '100%',
  },
});
